import cloneDeep from "lodash.clonedeep";

/**
 * Get all solutions which comply to the current active filters
 *
 * @param allSolutions
 * @param activeFilterTagUids
 * @returns {*}
 */
export const getFilteredAndSearchedSolutions = (
  allSolutions,
  activeFilterTagUids
) => {
  // optimization: if there is no filter active: return all solutions
  if (activeFilterTagUids.length === 0) {
    return allSolutions;
  }

  // filter out all solutions which don't comply with the currently selected filters
  return allSolutions.filter((solution) => {
    const activeFilterTagUidsArray = Array.from(activeFilterTagUids);
    // check if every active filter (tag) is present in the tags of the solution (we have a "AND" connection between all filters)
    return activeFilterTagUidsArray.every((filter) =>
      solution.tags.includes(filter)
    );
  });
};

/**
 * Get all filters that still have solutions that could be filtered
 *
 * @param allCategoriesWithTags
 * @param filteredAndSearchedSolutions
 * @returns {*}
 */
export const getAvailableCategoriesWithTags = (
  allCategoriesWithTags,
  filteredAndSearchedSolutions
) => {
  const availableCategoriesWithTags = allCategoriesWithTags.map((category) => {
    const categoryTmp = cloneDeep(category);
    categoryTmp.tags = categoryTmp.tags.filter((filterTag) =>
      // if some (any) solution has a tag which matches the filterTag
      filteredAndSearchedSolutions.some((solution) =>
        solution.tags.includes(filterTag.uid)
      )
    );
    return categoryTmp;
  });

  // remove the category entirely if there are no tags left
  return availableCategoriesWithTags.filter(
    (category) => category.tags.length !== 0
  );
};

/**
 * Returns available Categories and Tags based on given Solutions
 * @param searchedSolutions
 * @param activeFilterTagUids
 * @param allCategoriesWithTags
 * @returns {{filteredAndSearchedSolutions: Object, availableCategoriesWithTags: Object, currentPage: number}}
 */
export const getFilteredItems = (
  searchedSolutions,
  activeFilterTagUids,
  allCategoriesWithTags
) => {
  const filteredAndSearchedSolutions = getFilteredAndSearchedSolutions(
    searchedSolutions,
    activeFilterTagUids
  );
  const availableCategoriesWithTags = getAvailableCategoriesWithTags(
    allCategoriesWithTags,
    filteredAndSearchedSolutions
  );

  return {
    filteredAndSearchedSolutions: () => filteredAndSearchedSolutions,
    availableCategoriesWithTags: () => availableCategoriesWithTags,
    currentPage: 0,
  };
};
